import { Card, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import DashboardNavbar from 'components/DashboardNavbar';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import SCT from 'examples/CustomTypography/SCT';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { formatNumber } from 'layouts/player-management/helpers';
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import MDButton from 'components/MDButton';
import { getUserSkins } from 'services/skins/get-user-skins';
import { connectUserAffiliateCodeAdmin } from 'services/affiliate-codes/connect-user-affiliate-code';

function ShowPlayer() {
  const { id } = useParams();
  const [user, setUser] = useState({});
  const [buttonState, setButtonState] = useState('details');
  const [skins, setSkins] = useState([]);

  const [openConnectAffiliate, setOpenConnectAffiliate] = useState(false);
  const [affiliateCodeInput, setAffiliateCodeInput] = useState('');
  const [connecting, setConnecting] = useState(false);

  useEffect(() => {
    async function getData() {
      const res = await getUserSkins(id);
      // retrieve user's skins
      setSkins(res?.data?.skins);
      // retrieve user's personal data
      setUser(res?.data?.user);
    }
    getData();
  }, [id]);

  const handleConnectAffiliateCode = async () => {
    if (!affiliateCodeInput.trim()) {
      alert('Please enter an affiliate code');
      return;
    }

    setConnecting(true);
    try {
      const res = await connectUserAffiliateCodeAdmin(id, affiliateCodeInput.trim());
      if (res?.data?.success) {
        alert('User successfully connected with affiliate code');
        setOpenConnectAffiliate(false);
        setAffiliateCodeInput('');
        // Refresh user data
        const userRes = await getUserSkins(id);
        setUser(userRes?.data?.user);
      } else {
        alert(res?.response?.data?.message || 'Failed to connect user with affiliate code');
      }
    } catch (error) {
      console.error('Error connecting affiliate code:', error);
      alert(error?.response?.data?.message || 'Error connecting user with affiliate code');
    } finally {
      setConnecting(false);
    }
  };

  const selectValues = [
    {
      value: 'COMMON',
      name: 'Common',
      color: 'grey'
    },
    {
      value: 'RARE',
      name: 'Rare',
      color: 'blue'
    },
    {
      value: 'EPIC',
      name: 'Epic',
      color: 'purple'
    },
    {
      value: 'LEGENDARY',
      name: 'Legendary',
      color: 'gold'
    },
    {
      value: 'SUPREME',
      name: 'Supreme',
      color: 'orange'
    }
  ];

  function detailInformation() {
    return (
      <Card
        sx={{
          borderRadius: '12px',
          boxShadow: (theme) => theme.shadows[4],
          width: {
            xs: '90%',
            lg: '70%',
            xl: '50%'
          },
          height: '100%',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <TableContainer>
          <MDTypography sx={{ margin: '15px' }}>
            {user.firstName && user.lastName ? user.firstName + ' ' + user.lastName : 'User'}
            's Details
          </MDTypography>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>
                  <SCT>Nickname:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>{user.nickname ? user.nickname : 'Did not fetch nickname'}</SCT>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <SCT>Id:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>{user.id ? user.id : 'Did not fetch ID'}</SCT>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <SCT>Wallet Address:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>{user.walletAddress ? user.walletAddress : 'Did not fetch wallet address'}</SCT>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <SCT>First Name:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>
                    {user.firstName !== undefined
                      ? user.firstName !== null
                        ? user.firstName
                        : 'User does not have first name!'
                      : 'Did not fetch first name'}
                  </SCT>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <SCT>Last Name:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>
                    {user.lastName !== undefined
                      ? user.lastName !== null
                        ? user.lastName
                        : 'User does not have last name!'
                      : 'Did not fetch last name'}
                  </SCT>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <SCT>Email:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>
                    {user.email !== undefined
                      ? user.email !== null
                        ? user.email
                        : 'User does not have an email!'
                      : 'Did not fetch email'}
                  </SCT>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <SCT>Current coins amount:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>{user.coinsAmount >= 0 ? formatNumber(user.coinsAmount) : 'Did not fetch current coins amount'}</SCT>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <SCT>Current gems amount:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>{user.gemsAmount >= 0 ? formatNumber(user.gemsAmount) : 'Did not fetch current gems amount'}</SCT>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <SCT>Max gems owned:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>{user.maxGemsOwned >= 0 ? formatNumber(user.maxGemsOwned) : 'Did not fetch max gems owned'}</SCT>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <SCT>VIP status:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>{user.vip > 0 ? 'Yes' : 'No'}</SCT>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <SCT>Has Affiliate Access:</SCT>
                </TableCell>
                <TableCell>
                  <MDBox display='flex' alignItems='center' gap={1}>
                    <SCT>{user.hasAffiliateAccess ? 'Yes' : 'No'}</SCT>
                    {!user.hasAffiliateAccess && (
                      <MDButton
                        size='small'
                        variant='outlined'
                        color='primary'
                        onClick={() => setOpenConnectAffiliate(true)}
                      >
                        Connect Code
                      </MDButton>
                    )}
                  </MDBox>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <SCT>Is Affiliate Code Owner:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>{user.isAffiliateCodeOwner ? 'Yes' : 'No'}</SCT>
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>
                  <SCT>Total coins wagered:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>
                    {user?.totalCoinsWagered >= 0
                      ? formatNumber(user.totalCoinsWagered)
                      : 'Did not fetch total coins wagered'}
                  </SCT>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <SCT>Total coins won:</SCT>
                </TableCell>
                <TableCell>
                  <SCT>
                    {user?.totalCoinsWon >= 0 ? formatNumber(user.totalCoinsWon) : 'Did not fetch total coins won'}
                  </SCT>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    );
  }

  return (
    <>
      {/* <Can I='read' a='player'> */}
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display='flex' flexDirection='column' width='100%' marginTop='3%'>
          <MDBox>
            <MDButton
              color='info'
              variant={buttonState == 'details' ? 'contained' : 'outlined'}
              onClick={() => setButtonState('details')}
            >
              Player's details
            </MDButton>

            <MDButton
              color='info'
              variant={buttonState == 'events' ? 'contained' : 'outlined'}
              sx={{ marginLeft: '20px' }}
              onClick={() => setButtonState('events')}
            >
              {' '}
              Player's skins
            </MDButton>
          </MDBox>
          <MDBox display='flex' justifyContent='center' width='100%' marginTop='3%'>
            {buttonState == 'details' ? (
              <MDBox display='flex' justifyContent='center' width='100%'>
                {detailInformation()}
              </MDBox>
            ) : (
              <Grid>
                <MDTypography sx={{ margin: '15px' }}>User's owned skins</MDTypography>
                {skins && skins.length > 0 ? (
                  <Grid container xl={12} gap={'20px'} sx={{ padding: '15px' }}>
                    {skins.map((skin) => (
                      <MDBox
                        sx={{
                          background: '#27314f',
                          borderRadius: '10px',
                          border: '0.5px solid #fff',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'center',
                          paddingBottom: '15px'
                        }}
                      >
                        <MDTypography
                          sx={{
                            padding: '10px 0',
                            width: '100%',
                            textAlign: 'center',
                            background: '#121c35',
                            borderRadius: '10px 10px 0 0',
                            fontWeight: '600',
                            fontSize: '16px',
                            color: '#fff'
                          }}
                        >
                          Skin: {skin?.name}
                        </MDTypography>
                        <MDTypography
                          sx={{
                            padding: '10px 0',
                            width: '100%',
                            textAlign: 'center',
                            background: '#121c35',
                            borderRadius: '10px 10px 0 0',
                            fontWeight: '600',
                            fontSize: '16px',
                            color: '#fff'
                          }}
                        >
                          Avatar: {skin?.avatar?.name}
                        </MDTypography>
                        <MDTypography
                          sx={{
                            padding: '10px 0',
                            width: '100%',
                            textAlign: 'center',
                            background: '#121c35',
                            borderRadius: '10px 10px 0 0',
                            fontWeight: '600',
                            fontSize: '16px',
                            color: '#fff'
                          }}
                        >
                          Rarity:{' '}
                          <span style={{ color: selectValues.filter((obj) => obj?.value === skin?.rarity)[0]?.color }}>
                            {skin?.rarity}
                          </span>
                        </MDTypography>
                        <img src={skin?.smallImage?.url} style={{ width: '200px' }}></img>
                      </MDBox>
                    ))}
                  </Grid>
                ) : (
                  <MDBox
                    sx={{
                      width: '100%',
                      textAlign: 'center',
                      paddingBottom: '30px'
                    }}
                  >
                    <MDTypography sx={{ fontSize: '14px' }}>No Skins available.</MDTypography>
                  </MDBox>
                )}
              </Grid>
            )}
          </MDBox>
        </MDBox>
      </DashboardLayout>

      {/* Connect Affiliate Code Dialog */}
      <Dialog open={openConnectAffiliate} onClose={() => { setOpenConnectAffiliate(false); setAffiliateCodeInput(''); }} maxWidth='sm' fullWidth>
        <DialogTitle>Connect User with Affiliate Code</DialogTitle>
        <DialogContent>
          <MDBox py={2}>
            <MDTypography variant='body2' color='textSecondary' mb={2}>
              User: <strong>{user.nickname || user.email || user.id}</strong>
            </MDTypography>
            <TextField
              fullWidth
              label='Affiliate Code'
              placeholder='Enter affiliate code (e.g., AFFILIATE-XXXXX)'
              value={affiliateCodeInput}
              onChange={(e) => setAffiliateCodeInput(e.target.value.toUpperCase())}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !connecting) {
                  handleConnectAffiliateCode();
                }
              }}
              disabled={connecting}
              sx={{ mb: 2 }}
            />
            <MDTypography variant='caption' color='textSecondary'>
              This will set hasAffiliateAccess = true for this user and record their usage of the affiliate code.
            </MDTypography>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenConnectAffiliate(false); setAffiliateCodeInput(''); }} disabled={connecting}>
            Cancel
          </Button>
          <Button onClick={handleConnectAffiliateCode} variant='contained' color='primary' disabled={connecting || !affiliateCodeInput.trim()}>
            {connecting ? 'Connecting...' : 'Connect'}
          </Button>
        </DialogActions>
      </Dialog>
      {/* </Can>
      <Can not I='read' a='player'>
        <Navigate to='/dashboard' replace />
      </Can> */}
    </>
  );
}

export default ShowPlayer;
